import { Component } from 'react';
import { createPortal } from 'react-dom';

class InterstitialPortal extends Component {
  constructor(props) {
    super(props);
    this.portalElement = document.createElement('div');
    this.portalElement.setAttribute('data-testid', 'xorc-portal');
    this.portalContainer = props.portalContainer || document.body;
  }

  componentDidMount() {
    this.portalContainer.appendChild(this.portalElement);
  }

  componentWillUnmount() {
    this.portalContainer.removeChild(this.portalElement);
  }

  render() {
    return createPortal(this.props.children, this.portalElement);
  }

}

export { InterstitialPortal };